import { styled, Typography } from '@ori-ui/mui';
import type { PropsWithChildren } from 'react';
import React from 'react';

import { maxTextWidth } from '../../constants';

const Root = styled(Typography)(() => ({
  display: 'block',
  margin: '0 auto',
  maxWidth: maxTextWidth,
}));

export const ContentCaption: React.FC<PropsWithChildren> = ({ children }) => <Root variant="caption">{children}</Root>;
